import Banner from '../homeMods/Banner/Banner'
import Services from './Strategy/strategy'
const comp={
  Banner,
  Services
}
export default comp